import { Context } from "@nuxt/types";

import Api from "@/utils/api";

const DEFAULT_ITEM_LIMIT = 36;

export default class CollectionsApi extends Api {
  readonly url = process.client ? "/v1/collections/" : "/v1/collection/";

  constructor($axios: Context["$axios"]) {
    super("collectionService", $axios);
  }

  async getCollectionInfo({ id }: { id: string }) {
    return await this.request<CollectionInfoResponse>({
      method: "GET",
      url: process.client ? `${this.url}${id}` : `${this.url}get_collection`,
      params: {
        collection_id: process.client ? undefined : id,
      },
    });
  }

  async getCollectionItems({ id, limit = DEFAULT_ITEM_LIMIT, next }: { id: string; limit?: number; next?: string }) {
    return await this.request<CollectionItemsResponse>({
      method: "GET",
      url: process.client ? `${this.url}${id}/items` : `${this.url}get_collection_items`,
      params: {
        collection_id: process.client ? undefined : id,
        limit,
        next,
        includes: ["posts_v2"],
      },
    });
  }

  async getCreatorCollections({ id, limit = DEFAULT_ITEM_LIMIT, next }: { id: string; limit?: number; next?: string }) {
    return await this.request<ManyCollectionsResponse>({
      method: "GET",
      url: process.client ? `${this.url}` : `${this.url}get_collections`,
      params: {
        profile_id: id,
        limit,
        next,
        includes: ["latest_items", "posts_v2"],
        order: "rank",
      },
    });
  }
}
